<template>
  <NavbarOne />
  <PageBanner
    pageTitle="AUTHENTICATION"
    subTitle="Login / Register your Account"
    :pageBannerImage="pageBannerImg"
  />
  <LoginRegister />
  <SubscribeContent class="pt-100" />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import LoginRegister from "@/components/LoginRegister/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "LoginRegisterPage",
  components: {
    NavbarOne,
    PageBanner,
    LoginRegister,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-4.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>
